// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"DialogIE_dialogContent__3gp76","sectorInput":"DialogIE_sectorInput__1YBvn"};